import { Skeleton } from "@mui/material";
import ColumnContainer from "./ColumnContainer";
import { useEffect, useState } from "react";

export const SkeletonLoading = ({ type }) => {
  switch (type) {
    case "dashboard":
      return (
        <ColumnContainer style={{ width: "100%" }}>
          <Skeleton variant="rounded" width="100%" height="150px" />
          <Skeleton variant="rounded" width="100%" height="30vh" />
          <Skeleton variant="rounded" width="100%" height="30vh" />
        </ColumnContainer>
      );

    case "settings":
      return (
        <ColumnContainer style={{ width: "100%" }}>
          <Skeleton variant="rounded" width="100%" height="50px" />
          <Skeleton variant="rounded" width="100%" height="50px" />
          <Skeleton variant="rounded" width="100%" height="50px" />
        </ColumnContainer>
      );
    case "profile":
      return (
        <ColumnContainer
          style={{ width: "100%", height: "100%", paddingTop: "20px" }}
        >
          <Skeleton variant="rounded" width="100%" height="100%" />
        </ColumnContainer>
      );

    default:
      return (
        <ColumnContainer style={{ width: "100%" }}>
          <Skeleton variant="rounded" width="100%" height="80vh" />
        </ColumnContainer>
      );
  }
};
